/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsqueryRecommendationsPopularCategoriesGet$Plain$Params {
}

export function apiProductsqueryRecommendationsPopularCategoriesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryRecommendationsPopularCategoriesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Array<SalesArticleSummary>;
      }>;
    })
  );
}

apiProductsqueryRecommendationsPopularCategoriesGet$Plain.PATH = '/api/productsquery/recommendations/popular/categories';
